export const getFilteredParams = (searchParams: URLSearchParams) => {
  const params = new URLSearchParams(searchParams.toString());
  const excludeKeys = ["giataId", "searchId", "tokenId", "title"];

  excludeKeys.forEach((key) => {
    params.delete(key);
  });

  return params;
};
